import { toSafeUrl } from '@karakuri-web/common/utils'
import { AnswerContent } from '@karakuri-web/faq-type'

import { SkillApi } from './interface'
import { render } from './render'

const imgStyle = { maxWidth: '100%' }
export function renderAnswer(content: AnswerContent, skillApi: SkillApi, cardId: string) {
  const t = render(content, skillApi, cardId)

  // 回答の画像URLは会話カードを編集できる一般ユーザーも設定できるため、javascript: 等はリンク・画像にしない
  const image = toSafeUrl(content.image, ['http:', 'https:'])
  if (image) {
    return (
      <>
        {t}
        {!content.text ? null : <br />}
        <a href={image} target="_blank" rel="noopener noreferrer">
          <img src={image} alt={content.alt || ''} style={imgStyle} />
        </a>
      </>
    )
  }
  return t
}
